import React from 'react';
import Icon from '../../../components/AppIcon';

const ProgressIndicator = ({ currentStep, steps }) => {
  return (
    <div className="w-full bg-card border-b border-border">
      <div className="page-shell px-4 md:px-6 lg:px-8 py-4 md:py-6">
        <div className="flex items-center justify-between gap-2 md:gap-4 overflow-x-auto scrollbar-thin pb-2">
          {steps?.map((step, index) => {
            const isCompleted = index < currentStep;
            const isCurrent = index === currentStep;
            const isUpcoming = index > currentStep;

            return (
              <React.Fragment key={step?.id}>
                <div className="flex flex-col items-center gap-2 min-w-[80px] md:min-w-[120px]">
                  <div
                    className={`w-10 h-10 md:w-12 md:h-12 flex items-center justify-center transition-all duration-250 ${
                      isCompleted
                        ? 'bg-primary text-primary-foreground'
                        : isCurrent
                        ? 'bg-primary text-primary-foreground ring-4 ring-primary/20'
                        : 'bg-muted text-muted-foreground'
                    }`}
                  >
                    {isCompleted ? (
                      <Icon name="Check" size={20} />
                    ) : (
                      <span className="text-sm md:text-base font-medium">{index + 1}</span>
                    )}
                  </div>
                  <div className="text-center">
                    <p
                      className={`text-xs md:text-sm font-medium transition-colors duration-250 ${
                        isCurrent ? 'text-foreground' : 'text-muted-foreground'
                      }`}
                    >
                      {step?.label}
                    </p>
                  </div>
                </div>
                {index < steps?.length - 1 && (
                  <div className="flex-1 min-w-[20px] md:min-w-[40px] h-0.5 mt-[-20px] md:mt-[-24px]">
                    <div
                      className={`h-full transition-colors duration-250 ${
                        isCompleted ? 'bg-primary' : 'bg-muted'
                      }`}
                    />
                  </div>
                )}
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ProgressIndicator;